import { dispatch } from '@wordpress/data';
// import { REDUCER_KEY } from './store/name';
const REDUCER_KEY = 'wordpress';
const coreActions = [
  {
    id: 'OPEN_IN_WEBVIEW',
    title: 'Open WebView',
    template: 'common',
    subAction: {
      id: 'url',
      title: 'Choose URL',
      type: 'text'
    }
  },
  {
    id: 'OPEN_URL',
    title: 'Open URL',
    template: 'common',
    subAction: {
      id: 'url',
      title: 'Choose URL',
      type: 'text'
    }
  },
  {
    id: 'OPEN_CATEGORY',
    title: 'Open Post Category',
    template: 'wordpress',
    subAction: {
      id: 'PRODUCT_ID',
      title: 'Choose Category',
      type: 'select',
      dataSource: {
        kind: 'root',
        name: 'post_category',
        link: 'category',
        store: REDUCER_KEY
      }
    }
  },
  {
    id: 'OPEN_POST_PAGE',
    title: 'Open Post/Page',
    template: 'wordpress',
    subAction: {
      id: 'PRODUCT_ID',
      title: 'Choose Post/Page',
      type: 'select',
      dataSource: {
        kind: 'root',
        name: 'post_page',
        link: 'posts',
        store: REDUCER_KEY
      }
    }
  },
  {
    id: 'OPEN_TAG',
    title: 'Open Tag',
    template: 'wordpress',
    subAction: {
      id: 'ID',
      title: 'Choose tag',
      type: 'select',
      dataSource: {
        kind: 'root',
        name: 'tag',
        link: 'tag',
        store: REDUCER_KEY
      }
    }
  },
  { id: 'NO_ACTION', title: 'No Action', template: 'wordpress' }
];
// {
//   id: 'OPEN_PUSH_HISTORY',
//     title: 'Open push notification history',
//       template: 'woocommerce'
// }
export function registerActionType(actionType) {
  return dispatch('core/actions').addActionTypes(actionType);
}
export function registerActionTypes() {
  coreActions.map(registerActionType);
}
